import React from "react";
import "../../Test.scss";
import { Variants } from "../Varinats";
import "./style.scss";

const Card = ({
  details,
  final,
  last,

  answered,
  navigate,
  assignPoint,
  page,
}) => {
  return (
    <div className="test-card">
      {details.variants && details.page !== 0 && !final && (
        <div className="subsup">
          <span>{details.page}/5</span>
        </div>
      )}

      {final ? (
        <div className="test-card__result">
          <div className="test-card__badge">
            <img
              className="test-card__badge__image"
              src={require(`../../assets/img/${final.badge}.png`).default}
              alt={final.badge}
              data-aos="zoom-in-down"
            />

            <span className="test-card__badge__title">Вы — {final.title}</span>
          </div>

          <p className="test-card__finished centred">{final.text}</p>
        </div>
      ) : (
        <>
          <div className="test-card__details with-variants">
            <div className="test-card__details__side">
              <p
                className={`test-card__title ${
                  !details.variants ? "centred" : ""
                }`}
              >
                {details.question}
              </p>
            </div>
            {details.variants ? (
              <Variants
                page={page}
                assignPoint={assignPoint}
                variants={details.variants}
              />
            ) : (
              details.result && details.result
            )}
            <button
              disabled={!answered}
              onClick={navigate}
              className="button button--filled button--right"
            >
              Далее
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Card;
